export const enhanceUploadsWithDataNormalization = (uploads = []) => {
    const normalizedUploads = uploads.map(upload => {
        return {
            ...upload,
            title: upload.photoTitle,
            description: upload.photoDescription,
            location: upload.photoLocation,
            batchId: upload.photoBatchId
        };
    });

    return normalizedUploads;
};

export const enhanceUploads = (uploads = [], uploadsState = {}) => {
    if (!Array.isArray(uploads)) {
        return console.warn("Please pass array of uploads to enhanceUploads");
    }

    let enhancedUploads = uploads.map(upload => ({
        ...uploadsState[upload.id],
        ...upload
    }));

    enhancedUploads = enhanceUploadsWithDataNormalization(enhancedUploads);

    return enhancedUploads;
};
